<template>
  <div>
    <v-sheet class="pa-4">
      <h4 class="mb-4">Добавить настройку</h4>
      <challenge-form
        :pending="createPending"
        :error="createError"
        challenge-type="complexch"
        @submit="addSetting"
      />
    </v-sheet>
    <v-divider class="my-4"></v-divider>
    <div style="min-height: 6px">
      <v-progress-linear
        indeterminate
        color="yellow darken-2"
        :active="pending"
      ></v-progress-linear>
    </div>
    <div v-if="!!list.length">
      <v-simple-table class="mb-3">
        <template #default>
          <thead>
            <tr>
              <th class="text-left">ID Комплексного испытания</th>
              <th class="text-left" width="120px">Коэффициент</th>
              <th class="text-right"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in list" :key="item.id">
              <td>{{ item.complexch_id }}</td>
              <td>{{ item.coefficient }}</td>
              <td class="text-right">
                <v-hover v-slot="{ hover }">
                  <v-btn
                    :color="hover ? 'error' : 'grey lighten-1'"
                    title="Удалить настройку"
                    icon
                    @click.stop="removeSetting(item.id)"
                  >
                    <v-icon>mdi-trash-can</v-icon>
                  </v-btn>
                </v-hover>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>

      <app-pager
        :value="page"
        :total="total"
        :limit="limit"
        @input="getList"
      ></app-pager>
    </div>

    <div v-else-if="!pending">Список настроек пуст</div>
  </div>
</template>

<script>
import { apiClient } from "@/api";
import ChallengeForm from "./challenge/ChallengeForm.vue";

export default {
  name: "ComplexChallengeSettings",
  components: {
    ChallengeForm,
  },
  props: {
    track: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      pending: false,
      page: 1,
      limit: 40,
      total: 0,
      list: [],
      error: "",
      createError: "",
      createPending: false,
    };
  },

  created() {
    this.getList(1);
  },

  methods: {
    async getList(page = 1) {
      const { limit } = this;
      if (this.pending) return;
      this.pending = true;
      const offset = Math.ceil(page * limit - limit);
      try {
        const { data } = await apiClient({
          method: "GET",
          url: `/tracks/${this.track.id}/settings/complexch`,
          params: {
            limit,
            offset,
          },
        });
        this.list = data.results;
        this.page = page;
        if ("count" in data) {
          this.total = data.count;
        }
      } catch (error) {
        console.log("error", error);
        this.error = error.message || "Возникла непредвиденная ошибка";
      } finally {
        this.pending = false;
      }
    },
    async removeSetting(id) {
      this.list = this.list.filter((n) => n.id !== id);
      await apiClient({
        method: "DELETE",
        url: `/tracks/${this.track.id}/settings/complexch/${id}`,
      });

      if (this.list.length > 0) {
        this.getList(Math.max(this.page));
      } else {
        this.getList(Math.max(this.page - 1, 1));
      }
      this.$toast(`Настройка для комплексного испытания ${id} удалена.`, {
        type: "success",
      });
    },
    async addSetting(setting) {
      if (this.createPending) return;
      this.createError = "";
      this.createPending = true;
      try {
        await apiClient({
          method: "POST",
          url: `/tracks/${this.track.id}/settings/complexch`,
          data: {
            complexch_id: setting.id,
            coefficient: setting.score,
          },
        });
        this.getList(1);
      } catch (error) {
        this.createError = error.message;
      }
      this.createPending = false;
    },
  },
};
</script>

<style></style>
